import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = {
  // ── Auth ──
  loginAdmin: (u, p) => axios.post(`${BASE}/auth/admin`, { username: u, password: p }),
  loginTeacher: (u, p) => axios.post(`${BASE}/auth/teacher`, { username: u, password: p }),

  // ── Teachers ──
  getTeachers: () => axios.get(`${BASE}/teachers`),
  addTeacher: (data) => axios.post(`${BASE}/teachers`, data),
  deleteTeacher: (id) => axios.delete(`${BASE}/teachers/${id}`),
  updateTeacherPassword: (id, newPassword) => axios.put(`${BASE}/teachers/${id}/password`, { newPassword }),

  // ── Courses ──
  getCourses: () => axios.get(`${BASE}/courses`),
  addCourse: (data) => axios.post(`${BASE}/courses`, data),
  deleteCourse: (id) => axios.delete(`${BASE}/courses/${id}`),

  // ── Exams ──
  getExams: () => axios.get(`${BASE}/exams`),
  createExam: (data) => axios.post(`${BASE}/exams`, data),
  updateExam: (id, data) => axios.put(`${BASE}/exams/${id}`, data),
  deleteExam: (id) => axios.delete(`${BASE}/exams/${id}`),

  // ── Submissions ──
  getSubmissions: (examId) =>
    axios.get(`${BASE}/submissions${examId ? `?examId=${encodeURIComponent(examId)}` : ""}`),
  submitExam: (data) => axios.post(`${BASE}/submissions`, data),
  updateEssayScores: (id, essayScores, totalScore) =>
    axios.put(`${BASE}/submissions/${id}/essay`, { essayScores, totalScore }),

  // ── Override ──
  grantOverride: (subId) => axios.put(`${BASE}/submissions/${subId}/override`),
  getPendingOverrides: (teacherName) =>
    axios.get(`${BASE}/submissions/pending-override${teacherName ? `?teacherName=${encodeURIComponent(teacherName)}` : ""}`),
  checkOverrideStatus: (subId) => axios.get(`${BASE}/submissions?id=${subId}`),
  getSubmissionCount: (examId, since) => {
    const params = new URLSearchParams();
    if (examId) params.append("examId", examId);
    if (since) params.append("since", since);
    return axios.get(`${BASE}/submissions/count?${params.toString()}`);
  },
};

export default api;
